// Punto único de configuración de endpoints del backend para todo el frontend.
// BASE_URL está hardcodeada acá en vez de leerse de una variable de entorno
// (.env real no está en uso) — cambiarla es la única forma de apuntar el
// frontend a otro backend; ver detalle y por qué en README.md.
//const BASE_URL = "http://192.168.1.45:9021/";
// HU-007: nuevo servidor dockerizado (compartido con otros proyectos, con
// su propio Nginx Proxy Manager al que no tenemos acceso). HTTPS real vía
// Caddy propio con certificado autofirmado en el puerto 8443 (libre en
// este servidor) — necesario porque los navegadores bloquean cámara/
// micrófono (getUserMedia) fuera de HTTPS. El navegador pide aceptar el
// aviso de certificado una vez. La URL anterior queda comentada abajo por
// si hay que revertir mientras el nuevo servidor se valida.
//const BASE_URL = "https://miaapicifratransito02.cloudc5.com/";
// HU: BASE_URL relativa — la app y la API se sirven bajo el MISMO dominio
// (NPM enruta /api al backend y / al frontend), así funciona igual en
// cifranegra.cloudc5.com o en cualquier dominio que se agregue después
// (ej. avanzapais-jesusmaria.qrs.pe) sin recompilar.
const BASE_URL = "/";
const OPEN_CAGE_BASE_URL = "https://api.opencagedata.com/";
const OPEN_METEO_BASE_URL = "https://api.open-meteo.com/v1/";

// Configuración de autenticación
const AUTH_CONFIG = {
  TOKEN_KEY: 'jwt_token_cifra_negra',
  REFRESH_TOKEN_KEY: 'refresh_token_cifra_negra',
  TOKEN_EXPIRY_KEY: 'token_expiry_cifra_negra'
};

// APIs de Autenticación y Usuarios
const API_USUARIO = {
  login: `${BASE_URL}api/usuario/login/`,
  refreshToken: `${BASE_URL}api/usuario/token/refresh/`,
  registro: `${BASE_URL}api/usuario/registro/`,
  perfil: `${BASE_URL}api/usuario/perfil/`,
  cambiarMiPassword: `${BASE_URL}api/usuario/cambiar-mi-password/`,
  listar: `${BASE_URL}api/usuario/`,
  detalle: (id) => `${BASE_URL}api/usuario/${id}/`,
  cambiarRol: (id) => `${BASE_URL}api/usuario/${id}/cambiar-rol/`,
  descargarTemplate: `${BASE_URL}api/usuario/descargar-template/`,
  importarExcel: `${BASE_URL}api/usuario/importar-excel/`,
};

// APIs de Categorías (Tipos de Incidencias)
const API_CATEGORIA = {
  listar: `${BASE_URL}api/categoria/`,
  crear: `${BASE_URL}api/categoria/crear/`,
  detalle: (id) => `${BASE_URL}api/categoria/${id}/`,
  actualizar: (id) => `${BASE_URL}api/categoria/${id}/actualizar/`,
  eliminar: (id) => `${BASE_URL}api/categoria/${id}/eliminar/`,
};

// APIs de Incidencias (Denuncias Ciudadanas)
const API_INCIDENCIA = {
  // Endpoints públicos (sin autenticación)
  crearAnonima: `${BASE_URL}api/incidencia/crear-anonima/`,
  detallePublico: (id) => `${BASE_URL}api/incidencia/publico/${id}/`,
  buscarPorTicket: `${BASE_URL}api/incidencia/buscar/`,
  detallePorTicket: `${BASE_URL}api/incidencia/publico/`,
  // Pines del mapa base: solo lat/lng/categoria/estado, nunca datos del
  // denunciante (ver IncidenciaMapaSerializer en el backend).
  mapa: `${BASE_URL}api/incidencia/mapa/`,
  
  // Endpoints protegidos (requieren autenticación)
  listar: `${BASE_URL}api/incidencia/`,
  crear: `${BASE_URL}api/incidencia/crear/`,
  detallePanel: (id) => `${BASE_URL}api/incidencia/${id}/panel/`,
  gestionar: (id) => `${BASE_URL}api/incidencia/${id}/`,
  cambiarStatus: (id) => `${BASE_URL}api/incidencia/${id}/cambiar-status/`,
  cambiarStatusMasivo: `${BASE_URL}api/incidencia/cambiar-status-masivo/`,
  estadosDisponibles: `${BASE_URL}api/incidencia/estados/`,
  estadosPorIncidencia: (id) => `${BASE_URL}api/incidencia/${id}/estados-disponibles/`,
  estadisticas: `${BASE_URL}api/incidencia/estadisticas/`,
  alertasHoy: `${BASE_URL}api/incidencia/alertas-hoy/`,
  mapaHoy: `${BASE_URL}api/incidencia/mapa-hoy/`,
  mapaCalor: `${BASE_URL}api/incidencia/mapa-calor/`,
  // Comentarios en los puntos (HU)
  comentarios: (id) => `${BASE_URL}api/incidencia/${id}/comentarios/`,
  comentarioDetalle: (id) => `${BASE_URL}api/incidencia/comentario/${id}/`,
  comentariosPanel: `${BASE_URL}api/incidencia/comentarios-panel/`,
  comentarioModerar: (id) => `${BASE_URL}api/incidencia/comentario/${id}/moderar/`,
};

// APIs de Archivos (Fotos y Documentos)
const API_ARCHIVO = {
  upload: `${BASE_URL}api/archivo/upload/`,
  listarPorIncidencia: (incidenciaId) => `${BASE_URL}api/archivo/incidencia/${incidenciaId}/`,
  download: (archivoId) => `${BASE_URL}api/archivo/download/${archivoId}/`,
  info: (archivoId) => `${BASE_URL}api/archivo/info/${archivoId}/`,
  eliminar: (archivoId) => `${BASE_URL}api/archivo/delete/${archivoId}/`,
};

// APIs de Vías (Calles, Avenidas, etc.)
// Las rutas de detalle/actualizar/eliminar/buscar-ubicación estaban mal
// armadas acá (no coincidían con `via/urls.py` real) — nunca se notó porque
// el único consumidor hasta HU-009-B (`useVias.js`, wizard ciudadano) solo
// usa `listar`. Corregido al construir el módulo admin de vías.
const API_VIA = {
  listar: `${BASE_URL}api/via/`,
  buscar: `${BASE_URL}api/via/buscar/`,
  detalle: (id) => `${BASE_URL}api/via/detalle/${id}/`,
  crear: `${BASE_URL}api/via/crear/`,
  actualizar: (id) => `${BASE_URL}api/via/actualizar/${id}/`,
  eliminar: (id) => `${BASE_URL}api/via/eliminar/${id}/`,
  buscarPorUbicacion: `${BASE_URL}api/via/buscar-ubicacion/`,
  exportarExcel: `${BASE_URL}api/via/exportar-excel/`,
  exportarJson: `${BASE_URL}api/via/exportar-json/`,
  importarExcel: `${BASE_URL}api/via/importar-excel/`,
  importarJson: `${BASE_URL}api/via/importar-json/`,
};

// APIs de Geocodificación (OpenCage)
const API_GEOCODING = {
  openCageGeocode: (lat, lng, apiKey) =>
    `${OPEN_CAGE_BASE_URL}geocode/v1/json?q=${lat}+${lng}&key=${apiKey}`,
};

// APIs de Clima (Open-Meteo - GRATUITA SIN API KEY)
const API_WEATHER = {
  // Open-Meteo: https://open-meteo.com/ - Completamente gratuita sin API key
  
  // Endpoint para obtener temperatura actual y código del clima
  currentWeather: (lat, lng) => 
    `${OPEN_METEO_BASE_URL}forecast?latitude=${lat}&longitude=${lng}&current=temperature_2m,weather_code&timezone=auto`,
  
  // Endpoint para obtener pronóstico
  forecast: (lat, lng) => 
    `${OPEN_METEO_BASE_URL}forecast?latitude=${lat}&longitude=${lng}&hourly=temperature_2m&timezone=auto`,
};

// APIs de Historial (Auditoría Automática)
const API_HISTORIAL = {
  listar: `${BASE_URL}api/historial/`,
  detalle: (id) => `${BASE_URL}api/historial/detalle/${id}/`,
  historialIncidencia: (incidenciaId) => `${BASE_URL}api/historial/incidencia/${incidenciaId}/`,
  estadisticas: `${BASE_URL}api/historial/estadisticas/`,
  crearManual: `${BASE_URL}api/historial/crear-manual/`,
};

// APIs de Configuración de la instancia (marca blanca, HU-005)
const API_CONFIGURACION = {
  publica: `${BASE_URL}api/configuracion/publica/`,
  admin: `${BASE_URL}api/configuracion/`,
  bloqueos: `${BASE_URL}api/configuracion/bloqueos/`,
  bloqueoDetalle: (id) => `${BASE_URL}api/configuracion/bloqueos/${id}/`,
};

// APIs de Roles y Permisos (HU-009-A Fase 3)
const API_PERMISO = {
  listarPermisos: `${BASE_URL}api/permiso/permisos/`,
  listarRoles: `${BASE_URL}api/permiso/roles/`,
  crearRol: `${BASE_URL}api/permiso/roles/crear/`,
  detalleRol: (id) => `${BASE_URL}api/permiso/roles/${id}/`,
  actualizarPermisosRol: (id) => `${BASE_URL}api/permiso/roles/${id}/permisos/`,
};

// APIs de Notificaciones (Temporales - Simuladas)
const API_NOTIFICACIONES = {
  // WhatsApp API (Temporal - Simulada)
  whatsapp: {
    // En producción: "https://api.whatsapp.com/v1/messages"
    baseUrl: "https://api.whatsapp-simulado.com/v1/messages",
    token: "temp_whatsapp_token_12345",
    phoneNumberId: "temp_phone_id_67890",
    businessAccountId: "temp_business_id_11111"
  },
  
  // Correo Electrónico API (Temporal - Simulada)
  correo: {
    // En producción: "https://api.sendgrid.com/v3/mail/send" o similar
    baseUrl: "https://api.correo-simulado.com/v1/send",
    apiKey: "temp_correo_api_key_12345",
    fromEmail: "alertas@cifranegra.com",
    fromName: "Sistema CIFRA NEGRA"
  }
};

// Mantener compatibilidad con código existente
const API_CIFRA = {
  // Endpoint para alertas ciudadanas (público)
  alertas: API_INCIDENCIA.crearAnonima,
  alertasSearch: (documento) => `${BASE_URL}api/incidencia/buscar/?documento=${documento}`,
  
  // APIs de geocodificación
  openCageGeocode: API_GEOCODING.openCageGeocode,
  
  // APIs de notificaciones
  notificaciones: API_NOTIFICACIONES,
  
  // Exportar todas las APIs organizadas
  usuario: API_USUARIO,
  categoria: API_CATEGORIA,
  incidencia: API_INCIDENCIA,
  archivo: API_ARCHIVO,
  via: API_VIA,
  historial: API_HISTORIAL,
  configuracion: API_CONFIGURACION,
  permiso: API_PERMISO,
  geocoding: API_GEOCODING,
  weather: API_WEATHER,
  auth: AUTH_CONFIG,
};

export default API_CIFRA;
